"use client";

import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import CircleLoader from "@/components/common/ActionLoader";

import { Users, Boxes, ChartLine } from "lucide-react";
import {
  CreateTenantIcon,
  ManageSimTempIcon,
  ViewPlateFormIcon,
} from "@/lib/Images";

export default function Dashboard() {
  const navigate = useNavigate();
  const quickActions = [
    {
      title: "Create New Tenant",
      description:
        "Provision a new organization, assign campaigns, and launch a fully branded simulation environment.",
      buttonText: "Create New Tenant",
      icon: CreateTenantIcon,
      onClick: () => navigate("/tenants/create-organisation"),
    },
    {
      title: "Manage Simulation Templates",
      description:
        "Manage reusable simulation scenarios with rooms, interactions, and outcomes that can be deployed across tenants.",
      buttonText: "Go to Simulation Templates",
      icon: ManageSimTempIcon,
      onClick: () => navigate("/simulation-templates"),
    },
    {
      title: "View Platform Analytics",
      description:
        "Track performance across tenants, campaigns, and experiences with shareable insights and real-time metrics.",
      buttonText: "Go to Analytics",
      icon: ViewPlateFormIcon,
      onClick: () => navigate("/analytics"),
    },
  ];

  return (
    <div className="min-h-screen  text-neutral-100">
      <CircleLoader loading={false} size={64} />

      <div className="px-6 py-6 sm:px-8 lg:px-10">
        {/* Header */}
        <header className="mb-12">
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight mb-4">
            Welcome Admin 👋
          </h1>

          <p className="text-sm sm:text-base font-medium text-neutral-100/90 max-w-6xl">
            Manage tenants, publish simulation experiences, control reusable
            templates and share platform or tenant-level analytics from one
            control center.
          </p>
        </header>

        {/* Quick Actions */}
        <section>
          <h2 className="text-lg font-bold mb-4">Quick actions</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {quickActions.map((action) => {
              const Icon = action.icon;

              return (
                <div
                  key={action.title}
                  className="rounded-lg border border-[#2D5D8A] bg-[#1E426B]/70 px-8 py-8 min-h-[300px] flex flex-col items-center justify-center text-center shadow-lg"
                >
                  {/* Icon circle */}
                  <div className="mb-5 flex  items-center justify-center shadow-inner">
                    {/* <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#123F6A]"> */}
                    {/* <Icon className="h-9 w-9 text-[#12A8FF]" /> */}
                    <img
                      src={Icon} // 👈 replace with your image path
                      alt="icon"
                      className="h-32 w-32"
                    />
                    {/* </div> */}
                  </div>

                  <h3 className="text-xl font-bold mb-5">{action.title}</h3>

                  <p className="text-sm font-semibold leading-relaxed text-neutral-100/90 max-w-[310px] mb-7">
                    {action.description}
                  </p>

                  <Button
                    type="button"
                    onClick={action.onClick}
                    className="bg-brand-21 hover:bg-brand-22 text-neutral-100 rounded-md px-6 font-bold"
                  >
                    {action.buttonText}
                  </Button>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
}
